import { render, staticRenderFns } from "./HomeLoader.vue?vue&type=template&id=535d30c7&scoped=true"
import script from "./HomeLoader.vue?vue&type=script&lang=js"
export * from "./HomeLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535d30c7",
  null
  
)

export default component.exports